var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"mode":"vertical","unique-opened":"","default-active":_vm.routePath,"background-color":"#304156","text-color":"#fff"},on:{"select":_vm.handleSelect}},[_c('sidebar-item',{attrs:{"routes":_vm.menuData}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-909cf52a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/layout/components/sidebar/index.vue
// module id = null
// module chunks = 